import { useQuery } from '@tanstack/react-query';

import { MaintenanceRequester } from '@cobliteam/api-lib';
import type { VehicleOdometer } from '@cobliteam/api-lib/src/__generated__/graphql';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const maintenanceRequester = new MaintenanceRequester({
  host: env.herbieApiHost,
});

const QUERY_KEY = 'fleet_odometers';

const getFleetOdometers = () => {
  return useQuery<VehicleOdometer[]>({
    queryKey: [`${QUERY_KEY}`],
    queryFn: () => maintenanceRequester.getFleetOdometers(),
    refetchOnMount: false,
  });
};

export default { getFleetOdometers };
